import styled from "styled-components";
import { COLORS } from "../../constants/colors";

interface IListDetail {
    codigo: string | null;
    nombre: string;
    active: boolean;
    borderColor?: string;
    textColor?:string;
    method?: () => void;
}

const PersonInfo = styled.div<any>`
color: ${(props) => props.textColor} !important;
opacity: ${(props)=> !!props.opacity ? props.opacity:1};
border-bottom: 1px ${COLORS.black_text_color3} solid;
width: 90%;
padding: 1% 0% 0% 0%;
display: flex;
position: relative;
left: 5%;
//transition: all .06s;

.boxTitle {
    color:${(props)=>props.textColor};
    width: 90%;
    font-weight: 700;
    font-weight: bold;
}
.boxTitle h1{
        color: ${COLORS.blue_main(1)};
        font-size: x-large;
        font-weight: bold;
        margin-bottom: 0px;
    }
.boxTitle h3{
    color: ${(props)=>props.textColor};
    opacity: 0.7;
    margin-bottom: 0px;
}
.boxIcon{
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props)=>props.textColor};
    font-size: x-large;
    width: 10%;
}

${props => props.active && (`
    cursor: pointer;

    :active {
        opacity: 0.7;
    }

    :hover {
        box-shadow: 0px 1px 1px 0px ${COLORS.black_text_color3};
        //transform: scale(1.01);
    }

`)}`;

const EntidadEncuestaItem: React.FC<IListDetail>=({nombre,codigo,active,borderColor,textColor,method})=>{

    return  (
        <PersonInfo
        borderColor={borderColor}
        textColor={ active===true? textColor :COLORS.white_color1}
        active={active}
        onClick={!!active ? method : null}>
        <div className="boxTitle" >
            <h1>{nombre}</h1>
            <h3>{codigo}</h3>
        </div>
        <div className="boxIcon" >{<i className="fa-solid fa-circle-right"></i>}
        </div>
        </PersonInfo>
    )
}


export default EntidadEncuestaItem;